import React, { useEffect, useState } from 'react'
import features from '../../data/features.json'
import { Box, Paper, Typography } from '@mui/material'

const FeaturesGrid = (props) => {

  const [ featuresToRender, setFeaturesToRender ] = useState([]);

  useEffect(() => {

    switch (props?.isPro) {
      case undefined:
        setFeaturesToRender(features);
        break;
      case true:
        const proFeatures = features.filter((feature) => feature.isPro === true);
        setFeaturesToRender(proFeatures);
        break;
      case false:
        const basicFeatures = features.filter((feature) => feature.isPro === false);
        setFeaturesToRender(basicFeatures);
        break;
      default:
        setFeaturesToRender(features);
        break;
    }
    
    return () => {}

  }, [props?.isPro]);

  return (
    <Box>
      <Box sx={{display: "flex", flexWrap: "wrap", justifyContent: "center",}}>
        {
          featuresToRender.map(feature => {
            const imageSrc = require(`../../assets/svg/icons/white/${feature.slug}.svg`);
            return (
              <Box sx={{alignItems: "center", display: "flex", m:1,}} key={feature?.id}>
                <Paper
                  component="div"
                  sx={{
                    alignItems: "center",
                    backgroundColor: feature?.background_color,
                    display: "flex",
                    justifyContent: "center",
                    height: 60, width: 60,
                  }}
                >
                  <Box
                    component="img"
                    height={24}
                    src={imageSrc ? imageSrc : null}
                    width={24}
                  ></Box>
                </Paper>
                <Box sx={{pl: 2,}}>
                  <Box sx={{alignItems: "center", display: "flex",}}>
                    <Typography component="h3" variant="h6">{feature?.name}</Typography>
                    {
                      feature?.isPro ? (
                        <Box sx={{ml:1,}}>
                          <Typography sx={{ color: "#fff", backgroundColor: "#b71c1c", borderRadius: "4px", pl: .8, pr: .8,}}>Pro</Typography>
                        </Box>
                      ) : null
                    }
                  </Box>
                  <Typography maxWidth={275}>{feature?.short_description}</Typography>
                </Box>
              </Box>
            )
          })
        }
      </Box>
    </Box>
  )
}

export default FeaturesGrid